export default {"src":"/_next/static/media/looking-ahead-sm.mono.6a8c1791.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};